import type { OrgNodeKind } from '../types'
import { KIND_ICON } from '../utils'

type Props = {
  kind: OrgNodeKind
  size?: number
}

export const OrgTypeIcon = ({ kind, size = 14 }: Props) => {
  const Icon = KIND_ICON[kind]

  return <Icon size={size} />
}
